/**
 * @flow
 * @relayHash e077f1adef6bc6fae5a2a9c5762eff47
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LogVideoAdCompleteInput = {|
  userId: string,
  signatureArgumentString: string,
  signature: string,
  videoAdId: string,
  truexAdId: string,
  truexCreativeId: string,
  clientMutationId?: ?string,
|};
export type LogVideoAdCompleteMutationVariables = {|
  input: LogVideoAdCompleteInput
|};
export type LogVideoAdCompleteMutationResponse = {|
  +logVideoAdComplete: ?{|
    +success: boolean,
    +user: {|
      +vcCurrent: ?number,
      +videoAdEligible: ?boolean,
    |},
  |}
|};
export type LogVideoAdCompleteMutation = {|
  variables: LogVideoAdCompleteMutationVariables,
  response: LogVideoAdCompleteMutationResponse,
|};
*/


/*
mutation LogVideoAdCompleteMutation(
  $input: LogVideoAdCompleteInput!
) {
  logVideoAdComplete(input: $input) {
    success
    user {
      vcCurrent
      videoAdEligible
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "LogVideoAdCompleteInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "success",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "vcCurrent",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "videoAdEligible",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "LogVideoAdCompleteMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "logVideoAdComplete",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "LogVideoAdCompletePayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "LogVideoAdCompleteMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "logVideoAdComplete",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "LogVideoAdCompletePayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "LogVideoAdCompleteMutation",
    "id": null,
    "text": "mutation LogVideoAdCompleteMutation(\n  $input: LogVideoAdCompleteInput!\n) {\n  logVideoAdComplete(input: $input) {\n    success\n    user {\n      vcCurrent\n      videoAdEligible\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ac0e9497dcbcafa13301de23a94931b0';
module.exports = node;
